var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCGancho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7663 48.4397C89.7778 48.4397 90.5696 48.8659 91.1418 49.7183C91.7139 50.5651 92 51.7282 92 53.2075C92 54.7308 91.7037 55.9103 91.1111 56.7462C90.5236 57.5821 89.7216 58 88.705 58C87.6986 58 86.9093 57.6068 86.3372 56.8204H86.1762L85.7854 57.835H84V45H86.3372V47.986C86.3372 48.3655 86.3065 48.9731 86.2452 49.809H86.3372C86.8838 48.8962 87.6935 48.4397 88.7663 48.4397ZM88.0153 50.4524C87.4381 50.4524 87.0166 50.6449 86.751 51.0298C86.4853 51.4093 86.3474 52.0389 86.3372 52.9188V53.191C86.3372 54.1808 86.4725 54.8902 86.7433 55.3192C87.0192 55.7481 87.4534 55.9626 88.046 55.9626C88.5262 55.9626 88.9068 55.7261 89.1877 55.2532C89.4738 54.7747 89.6169 54.0819 89.6169 53.1745C89.6169 52.2671 89.4738 51.588 89.1877 51.1371C88.9017 50.6806 88.5109 50.4524 88.0153 50.4524Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 75L29.7735 65L18.2265 65L24 75ZM24 25L18.2265 35L29.7735 35L24 25ZM25 66L25 34L23 34L23 66L25 66Z",
    fill: "#008746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8567 66.9995L80.6736 57.0246L69.1267 56.9745L74.8567 66.9995ZM75 34L69.1831 43.9748L80.73 44.025L75 34ZM75.8958 58.0039L75.9609 43.0043L73.9609 42.9956L73.8958 57.9952L75.8958 58.0039Z",
    fill: "#005AE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2909 55.8277L14.8175 54.5185H14.7533C14.3414 55.0755 13.9161 55.4631 13.4774 55.6813C13.0441 55.8938 12.4771 56 11.7763 56C10.9151 56 10.2357 55.7359 9.73821 55.2076C9.24607 54.6793 9 53.9271 9 52.9509C9 51.9288 9.33166 51.1766 9.99498 50.6942C10.6637 50.2061 11.6693 49.9363 13.012 49.8846L14.5687 49.8329V49.4109C14.5687 48.4347 14.1033 47.9466 13.1725 47.9466C12.4557 47.9466 11.6132 48.1792 10.6449 48.6443L9.8345 46.8699C10.8669 46.29 12.0117 46 13.2688 46C14.4724 46 15.3952 46.2814 16.0371 46.8441C16.679 47.4068 17 48.2624 17 49.4109V55.8277H15.2909ZM14.5687 51.3661L13.6219 51.4005C12.9104 51.4235 12.3808 51.5613 12.0331 51.814C11.6854 52.0666 11.5115 52.4513 11.5115 52.9681C11.5115 53.7089 11.9074 54.0792 12.6991 54.0792C13.2661 54.0792 13.7182 53.9041 14.0552 53.5538C14.3975 53.2036 14.5687 52.7384 14.5687 52.1585V51.3661Z",
    fill: "#008746"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34H38",
    stroke: "#008746",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 66H38",
    stroke: "#008746",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 64C57.0645 64 64 57.517 64 50C64 42.483 57.0645 36 48 36C38.9355 36 32 42.483 32 50C32 57.517 38.9355 64 48 64ZM48 66C57.9411 66 66 58.8366 66 50C66 41.1634 57.9411 34 48 34C38.0589 34 30 41.1634 30 50C30 58.8366 38.0589 66 48 66Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9696 44.8112C51.8059 44.8112 53.5887 41 56.1305 41C59.3079 41 61.0001 46.098 61.0001 50.2558C61.0001 54.4137 59.8511 58.5052 56.6729 58.9672C53.4947 59.4292 52.5291 54.8594 54.6473 54.8594",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCGancho);
export default __webpack_public_path__ + "static/media/c_gancho.f54e6473ba72d724ab49a38d6fcb7fff.svg";
export { ForwardRef as ReactComponent };